import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { StringViewModel } from 'src/app/_models/generatedModels';
import { AdminCallForPapersService } from 'src/app/_services/generatedServices';

@Component({
  selector: 'bxl-add-note-modal',
  templateUrl: 'add-note-modal.component.html',
})
export class AddNoteModalComponent implements OnInit {
  initialized = false;
  @Input()
  organizationId: string;

  @Input()
  conferenceId: number;
  @Input()
  submissionId: number;
  submitComplete: Promise<{}> | undefined;
  items: string[] = [];
  filterChanged: Subject<string> = new Subject<string>();
  filter = '';
  noteText = '';

  constructor(private cfpService: AdminCallForPapersService, private activeModal: NgbActiveModal) {
    this.filterChanged.pipe(debounceTime(500), distinctUntilChanged()).subscribe((model) => {
      this.filter = model;
      this.getUsers();
    });
  }

  onSave() {
    this.submitComplete = new Promise((resetButton: any, reject) => {
      var model = new StringViewModel();
      model.value = this.noteText;
      this.cfpService.createNote(this.organizationId, this.conferenceId, this.submissionId, model).subscribe((notes) => {
        this.activeModal.close(notes);
        resetButton();
      }, resetButton());
    });
  }

  onCancel() {
    this.activeModal.dismiss();
  }

  ngOnInit(): void {
    this.initialized = true;
  }

  getUsers() {
    this.cfpService.searchAdminUsers(this.organizationId, this.filter).subscribe((result) => {
      this.items = result.map((x) => x.firstName + '-' + x.lastName);
    });
  }

  searchTerm(evt: any) {
    this.filterChanged.next(evt);
    console.log(evt);
  }
}
